<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="title-wrapper">
      <h1 class="title-default">Reajuste de Preços dos Produtos</h1>
      <p class="welcome-message">
        <button mat-icon-button routerLink="../">
          <mat-icon>arrow_back</mat-icon>
        </button>
        {{ stepSubtitle }}
      </p>
    </div>

    <app-wizard-steps [passos]="etapas" [descricoes]="descricoesEtapas" [passoAtual]="etapaAtual" [clicavel]="true"
      (passoSelecionado)="onEtapaSelecionada($event)"></app-wizard-steps>

    <!-- ============ ETAPA 1 — FILTRAR PRODUTOS ============ -->
    @if (etapaAtual === 0) {
    <form [formGroup]="filtroForm">
      <div class="section-container">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">sell</mat-icon>
          <span>Lista de preço a ser reajustada</span>
        </div>

        <div class="row g-3 align-items-center">
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>Lista de preços *</mat-label>
              <mat-select formControlName="idListaPreco">
                @for (lista of listasPreco; track lista.idListaPreco) {
                <mat-option [value]="lista.idListaPreco">{{ lista.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-8">
            <small class="d-block">
              Os preços reajustados serão gravados nesta lista. Apenas listas com método manual podem ser reajustadas.
            </small>
          </div>
        </div>

        @if (exibeAvisoListaDiferentePadrao) {
        <app-alert-card type="warning" title="Atenção">
          Produtos que ainda não fazem parte da lista '{{ listaSelecionada?.descricao }}' aparecerão desmarcados na
          próxima etapa. Se você marcá-los, eles serão adicionados à lista '{{ listaSelecionada?.descricao }}' com o
          novo preço calculado, tendo como base o preço da Lista Padrão de cada produto.
        </app-alert-card>
        }
      </div>

      <section class="section-container filtros-section">
        <div class="filtros-heading">
          <div class="filtros-heading-title">
            <mat-icon class="material-symbols-outlined">filter_list</mat-icon>
            <span>Filtros de pesquisa</span>
          </div>

          <div class="favoritos-toolbar">
            <mat-form-field appearance="outline" class="favoritos-field" subscriptSizing="dynamic">
              <mat-label>Filtros favoritos</mat-label>
              <mat-select [value]="favoritoSelecionadoId" (selectionChange)="selecionarFavorito($event.value)">
                <mat-option [value]="null">Selecionar favorito</mat-option>
                @for (favorito of favoritos; track favorito.idProdutoFiltroFavorito) {
                <mat-option [value]="favorito.idProdutoFiltroFavorito">{{ favorito.nome }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            @if (hasFavoritoSelecionado) {
            <button type="button" mat-stroked-button class="btn-secondary favoritar-button"
              (click)="removerFavoritoSelecionado()">
              <mat-icon class="material-symbols-outlined">delete</mat-icon> Remover favorito
            </button>
            } @else if (exibirBotaoFavoritar) {
            <button type="button" mat-stroked-button class="btn-secondary favoritar-button"
              (click)="abrirFavoritarFiltros()">
              <mat-icon class="material-symbols-outlined">star</mat-icon> Favoritar filtros
            </button>
            }
          </div>
        </div>

        <div class="row g-3">
          <div class="col-12 col-md-4">
            <app-select-pesquisavel label="Categoria" [control]="$any(filtroForm.get('idCategoria'))" [idField]="'id'"
              [nameField]="'descricao'" [offlineList]="listaCategoria" [isOptional]="true" hint="Buscar categoria">
            </app-select-pesquisavel>
          </div>

          <div class="col-12 col-md-4">
            <app-select-pesquisavel label="Marca" [control]="$any(filtroForm.get('idMarca'))" [idField]="'id'"
              [nameField]="'descricao'" [offlineList]="listaMarca" [isOptional]="true" hint="Nome da marca">
            </app-select-pesquisavel>
          </div>

          <div class="col-12 col-md-4">
            <app-select-pesquisavel label="Fornecedor" [control]="$any(filtroForm.get('listIdFornecedor'))"
              [idField]="'id'" [nameField]="'descricao'" [apiUrl]="urlFornecedor" [multiple]="true" [isOptional]="true"
              hint="Razão social ou nome fantasia">
            </app-select-pesquisavel>
          </div>

          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>Produto</mat-label>
              <input matInput formControlName="produto" placeholder="Descrição ou código SKU">
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>Exibir custo</mat-label>
              <mat-select formControlName="exibirCusto">
                <mat-option [value]="exibirCustoEnum.Nao">Não</mat-option>
                <mat-option [value]="exibirCustoEnum.CustoCompra">Custo da Compra</mat-option>
                <mat-option [value]="exibirCustoEnum.CustoMedio">Custo Médio</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4">
            <app-select-pesquisavel label="Tags dos produtos" [control]="$any(filtroForm.get('listIdTag'))"
              [idField]="'idTag'" [nameField]="'nome'" [offlineList]="listaTag" [multiple]="true" [isOptional]="true">
            </app-select-pesquisavel>
          </div>

          <div class="col-12 d-flex gap-4">
            <mat-checkbox formControlName="soPromo">Exibir apenas produtos com promoção</mat-checkbox>
            <mat-checkbox formControlName="exibirImg">Exibir imagem dos produtos</mat-checkbox>
          </div>
        </div>
      </section>
    </form>
    }

    <!-- ============ ETAPA 2 — SELECIONAR PRODUTOS ============ -->
    @if (etapaAtual === 1) {
    @if (isBuscando) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (linhas.length === 0) {
    <app-empty-list [title]="'A consulta não retornou nenhum registro.'"
      [subTitle]="'Tente refazer a consulta com outros parâmetros.'"></app-empty-list>
    } @else {
    @if (qtdForaDaListaEtapa2 > 0) {
    <app-alert-card type="info" title="Adicionar produtos à lista">
      {{ qtdForaDaListaEtapa2 }} produto(s) encontrados ainda não pertencem à lista '{{ listaSelecionada?.descricao }}'
      (marcados como "preço padrão" na coluna Preço Atual) e vieram desmarcados. Marque-os se quiser incluí-los na
      lista '{{ listaSelecionada?.descricao }}' com o novo preço calculado.
    </app-alert-card>
    }

    <div class="d-flex align-items-center mb-3">
      <span class="text-bold">Produtos ({{ linhas.length }})</span>
    </div>

    <div class="table-responsive desktop-view">
      <table mat-table [dataSource]="linhas">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="w-checkbox">
            <mat-checkbox [checked]="todosSelecionadosEtapa2" (change)="toggleTodosEtapa2()"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let linha" class="w-checkbox">
            <mat-checkbox [(ngModel)]="linha.selecionadoEtapa2"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="imagem">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let linha">
            @if (linha.imagemUrl) {
            <img [src]="linha.imagemUrl" class="produto-thumb" alt="">
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="descricao">
          <th mat-header-cell *matHeaderCellDef>Descrição</th>
          <td mat-cell *matCellDef="let linha">{{ linha.nome }}</td>
        </ng-container>

        <ng-container matColumnDef="codigo">
          <th mat-header-cell *matHeaderCellDef>Código</th>
          <td mat-cell *matCellDef="let linha">{{ linha.codigoSku }}</td>
        </ng-container>

        <ng-container matColumnDef="unidade">
          <th mat-header-cell *matHeaderCellDef class="text-center">Unidade</th>
          <td mat-cell *matCellDef="let linha" class="text-center">{{ linha.unidadeMedida }}</td>
        </ng-container>

        <ng-container matColumnDef="custo">
          <th mat-header-cell *matHeaderCellDef class="text-end">Custo</th>
          <td mat-cell *matCellDef="let linha" class="text-end">{{ linha.custo | abnt:'preco' }}</td>
        </ng-container>

        <ng-container matColumnDef="precoAtual">
          <th mat-header-cell *matHeaderCellDef class="text-end">Preço Atual</th>
          <td mat-cell *matCellDef="let linha" class="text-end">
            <div>{{ linha.precoAtual | abnt:'preco' }}</div>
            @if (linha.isPrecoBase) {
            <small class="preco-base-note">(preço padrão — não está nesta lista)</small>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colunasEtapa2"></tr>
        <tr mat-row *matRowDef="let row; columns: colunasEtapa2"></tr>
      </table>
    </div>

    <div class="mobile-view">
      <div class="d-flex align-items-center gap-2 mb-2 select-all-mobile">
        <mat-checkbox [checked]="todosSelecionadosEtapa2" (change)="toggleTodosEtapa2()"></mat-checkbox>
        <span class="text-bold">Selecionar todos</span>
      </div>
      @for (linha of linhas; track linha.idProduto) {
      <div class="card-mobile mb-3">
        <div class="card-header-mobile d-flex align-items-center gap-2">
          <mat-checkbox [(ngModel)]="linha.selecionadoEtapa2"></mat-checkbox>
          <div class="d-flex flex-column">
            <span class="text-bold">{{ linha.nome }}</span>
            <small>SKU: {{ linha.codigoSku }}</small>
          </div>
        </div>
        <div class="card-body-mobile p-3">
          <div class="row">
            <div class="col-6 mb-2">
              <small class="d-block">Unidade</small>
              <span>{{ linha.unidadeMedida }}</span>
            </div>
            <div class="col-6 mb-2">
              <small class="d-block">Preço Atual</small>
              <span>{{ linha.precoAtual | abnt:'preco' }}</span>
              @if (linha.isPrecoBase) {
              <small class="preco-base-note d-block">(preço padrão — não está nesta lista)</small>
              }
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    }
    }

    <!-- ============ ETAPA 3 — INFORMAR REAJUSTE ============ -->
    @if (etapaAtual === 2) {
    <div class="section-container">
      <div class="section-title">
        <mat-icon class="material-symbols-outlined">tune</mat-icon>
        <span>Painel de Reajuste</span>
      </div>

      <div class="row g-3 align-items-start">
        <div class="col-12 col-md-6">
          <small class="d-block mb-1">Ação</small>
          <mat-button-toggle-group class="toggle-group-responsive" [value]="painelAcao"
            (change)="setAcao($event.value)">
            <mat-button-toggle [value]="acaoEnum.Somar"><mat-icon class="material-symbols-outlined">add</mat-icon>
              Somar</mat-button-toggle>
            <mat-button-toggle [value]="acaoEnum.Subtrair"><mat-icon class="material-symbols-outlined">remove</mat-icon>
              Subtrair</mat-button-toggle>
          </mat-button-toggle-group>
          <small class="d-block mt-1">Use a ação Subtrair para aplicar desconto.</small>
        </div>

        <div class="col-12 col-md-6">
          <small class="d-block mb-1">Tipo de reajuste</small>
          <mat-button-toggle-group class="toggle-group-responsive" [value]="painelTipo"
            (change)="setTipo($event.value)">
            <mat-button-toggle [value]="unidadeEnum.Percentual"><mat-icon
                class="material-symbols-outlined">percent</mat-icon> Percentual</mat-button-toggle>
            <mat-button-toggle [value]="unidadeEnum.ValorFixo"><mat-icon
                class="material-symbols-outlined">attach_money</mat-icon> Valor Fixo</mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <div class="col-12 col-md-6">
          <small class="d-block mb-1 spacer-invisivel">.</small>
          <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
            <mat-label>{{ labelValor }}</mat-label>
            <input matInput type="text" [(ngModel)]="painelValor" [ngModelOptions]="{standalone: true}"
              [currencyMask]="valorMask" (ngModelChange)="onValorChange()">
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <small class="d-block mb-1 spacer-invisivel">.</small>
          <button type="button" mat-stroked-button class="btn-secondary w-100" (click)="aplicarAosSelecionados()">
            <mat-icon class="material-symbols-outlined">done_all</mat-icon> Aplicar aos selecionados
          </button>
        </div>
      </div>

      <small class="d-block mt-3">
        Quer reajustar apenas alguns produtos? É só marcar as caixas de seleção na tabela para escolher o grupo que
        deseja alterar.
      </small>

      @if (hasItemComPrecoInvalido) {
      <app-alert-card type="error" title="Atenção">
        Há produtos com Novo Preço menor ou igual a R$ 0,00. Ajuste o reajuste para habilitar o botão Salvar.
      </app-alert-card>
      }
    </div>

    <div class="d-flex align-items-center mb-3">
      <span class="text-bold">Produtos ({{ linhasParaReajuste.length }})</span>
    </div>

    <div class="table-responsive desktop-view">
      <table mat-table [dataSource]="linhasParaReajuste">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="w-checkbox">
            <mat-checkbox [checked]="todosMarcadosEtapa3" (change)="toggleTodosEtapa3()"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let linha" class="w-checkbox">
            <mat-checkbox [(ngModel)]="linha.aplicarNestaLinha" [ngModelOptions]="{standalone: true}"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="descricao">
          <th mat-header-cell *matHeaderCellDef>Descrição</th>
          <td mat-cell *matCellDef="let linha">{{ linha.nome }}</td>
        </ng-container>

        <ng-container matColumnDef="codigo">
          <th mat-header-cell *matHeaderCellDef>Código</th>
          <td mat-cell *matCellDef="let linha">{{ linha.codigoSku }}</td>
        </ng-container>

        <ng-container matColumnDef="unidade">
          <th mat-header-cell *matHeaderCellDef class="text-center">Unidade</th>
          <td mat-cell *matCellDef="let linha" class="text-center">{{ linha.unidadeMedida }}</td>
        </ng-container>

        <ng-container matColumnDef="precoAtual">
          <th mat-header-cell *matHeaderCellDef class="text-end">Preço Atual</th>
          <td mat-cell *matCellDef="let linha" class="text-end">{{ linha.precoAtual | abnt:'preco' }}</td>
        </ng-container>

        <ng-container matColumnDef="novoPreco">
          <th mat-header-cell *matHeaderCellDef class="text-end">Novo Preço</th>
          <td mat-cell *matCellDef="let linha" class="text-end">
            <div class="novo-preco-wrapper">
              @if (linha.novoPreco <= 0) { <mat-icon class="material-symbols-outlined icone-bloqueio">cancel</mat-icon>
                }
                <input class="input-novo-preco" type="text" inputmode="decimal"
                  [currencyMask]="getDynamicCurrencyMask()" [(ngModel)]="linha.novoPreco"
                  (ngModelChange)="onNovoPrecoManual(linha)">
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="variacao">
          <th mat-header-cell *matHeaderCellDef class="text-end">Variação</th>
          <td mat-cell *matCellDef="let linha" class="text-end">
            <span [ngClass]="variacao(linha) >= 0 ? 'reajuste-positivo' : 'reajuste-negativo'">
              {{ variacao(linha) | number: '1.2-2' }}%
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colunasEtapa3"></tr>
        <tr mat-row *matRowDef="let row; columns: colunasEtapa3"></tr>
      </table>
    </div>

    <div class="mobile-view">
      <div class="d-flex align-items-center gap-2 mb-2 select-all-mobile">
        <mat-checkbox [checked]="todosMarcadosEtapa3" (change)="toggleTodosEtapa3()"></mat-checkbox>
        <span class="text-bold">Selecionar todos</span>
      </div>
      @for (linha of linhasParaReajuste; track linha.idProduto) {
      <div class="card-mobile mb-3">
        <div class="card-header-mobile d-flex align-items-center gap-2">
          <mat-checkbox [(ngModel)]="linha.aplicarNestaLinha" [ngModelOptions]="{standalone: true}"></mat-checkbox>
          <div class="d-flex flex-column">
            <span class="text-bold">{{ linha.nome }}</span>
            <small>SKU: {{ linha.codigoSku }}</small>
          </div>
        </div>
        <div class="card-body-mobile p-3">
          <div class="row">
            <div class="col-6 mb-2">
              <small class="d-block">Preço Atual</small>
              <span>{{ linha.precoAtual | abnt:'preco' }}</span>
            </div>
            <div class="col-6 mb-2">
              <small class="d-block">Novo Preço</small>
              <input class="input-novo-preco" type="text" inputmode="decimal" [currencyMask]="getDynamicCurrencyMask()"
                [(ngModel)]="linha.novoPreco" (ngModelChange)="onNovoPrecoManual(linha)">
            </div>
            <div class="col-6 mb-2">
              <small class="d-block">Variação</small>
              <span [ngClass]="variacao(linha) >= 0 ? 'reajuste-positivo' : 'reajuste-negativo'">
                {{ variacao(linha) | number: '1.2-2' }}%
              </span>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>

<app-footer-action [salvarLabel]="labelBotaoPrimario" [cancelarLabel]="labelBotaoSecundario"
  [isLoadingSalvar]="isBuscando || isSalvando" [isSalvarDisabled]="botaoPrimarioDesabilitado"
  (cancelar)="onBotaoSecundario()" (salvar)="onBotaoPrimario()">
</app-footer-action>